import * as React from "react";
import { useState } from "react";
import { VideoReader } from "./video_reader";
import { Exam, Question } from ".";
import { ExamResult } from "./exam";
import { sendFormationStepResult } from "@/api/tutor";

interface StepProps {
  stepNumber: string;
  title: string;
  videoUrl: string;
  redirectURL: string;
  questions: Question[];
  skipVideo?: boolean; // Optional prop to skip video requirement
}

function VideoView({ 
  url, 
  onFinish, 
  skipVideo = false 
}: { 
  url: string; 
  onFinish: () => void; 
  skipVideo?: boolean;
}) {
  // If skipVideo is true, automatically finish the video
  React.useEffect(() => {
    if (skipVideo) {
      onFinish();
    }
  }, [skipVideo, onFinish]);

  if (skipVideo) {
    return null;
  }

  return (
    <VideoReader
      url={url}
      onFinish={onFinish}
      width="100%"
      height="auto"
      className="example-video-reader"
    />
  );
}

export function Step({
  stepNumber,
  title,
  videoUrl,
  redirectURL,
  questions,
  skipVideo = false
}: StepProps) {
  const [videoListened, setVideoListened] = useState(skipVideo);
  
  const onCompleted = (results: ExamResult[]) => {
    sendFormationStepResult({
      step: stepNumber, 
      correctAnswers: results.filter(r => r.isCorrect).length, 
      totalQuestions: results.length, 
      scoreText: results.map(r => r.summary).join("\n")
    });
  };

  return (
    <div className="max-w-full">
      <h1 className="text-2xl font-bold mb-4">{title}</h1>
      {videoListened ? (
        <div>
          <Exam 
            questions={questions} 
            onComplete={onCompleted} 
            redirectURL={redirectURL}
          />
        </div>
      ) : (
        <VideoView 
          url={videoUrl} 
          onFinish={() => setVideoListened(true)}
          skipVideo={skipVideo}
        />
      )}
    </div>
  );
} 